import { Component, OnInit, inject } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { Button } from 'primeng/button';
import { HeaderComponent } from '../../atoms/header/header.component';
import { DividerModule } from 'primeng/divider';
import { FormsModule } from '@angular/forms';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TrackingService } from '../../../services/tracking/tracking.service';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [
    DialogModule,
    Button,
    HeaderComponent,
    DividerModule,
    FormsModule,
    InputSwitchModule,
  ],
  templateUrl: './cookie-consent.component.html',
  styleUrl: './cookie-consent.component.scss',
})
export class CookieConsentComponent implements OnInit {
  displayDialog = false; // Bool flag to toggle p-dialog visibility
  trackingConsent = false; // Toggle state for stats tracking

  private readonly COOKIE_NAME = 'hyperion-cookie-consent-v2';

  constructor(private trackingService: TrackingService) {}

  ngOnInit(): void {
    this.displayDialog = !this.hasCookieConsent();
    this.trackingConsent = this.trackingService.hasTrackingConsent();
  }

  /**
   * Checks if the user has given consent for cookies.
   *
   * @return {boolean} Returns true if cookie consent has been granted, otherwise false.
   */
  hasCookieConsent(): boolean {
    return (
      document.cookie.includes(`${this.COOKIE_NAME}=true`) ||
      localStorage.getItem(this.COOKIE_NAME) === 'true'
    );
  }

  /**
   * Accepts only necessary cookies, denying statistical tracking.
   */
  acceptOnlyNecessary(): void {
    this.trackingConsent = false;
    this.trackingService.setConsent(false);
    this.saveMainConsent();
  }

  /**
   * Accepts all cookies, enabling statistical tracking.
   */
  acceptAll(): void {
    this.trackingConsent = true;
    this.trackingService.setConsent(true);
    this.saveMainConsent();
  }

  /**
   * Stores the current state of selections.
   */
  saveConsent(): void {
    this.trackingService.setConsent(this.trackingConsent);
    this.saveMainConsent();
  }

  /**
   * Stores user consent in a cookie and optionally hides the consent dialog.
   * The cookie is valid for 1 year.
   */
  private saveMainConsent(): void {
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${this.COOKIE_NAME}=true; expires=${expiryDate.toUTCString()}; path=/`;
    localStorage.setItem(this.COOKIE_NAME, 'true');
    this.displayDialog = false;
  }
}
